(function(){
  if(window.__ddiCardHoverImgInit) return;
  window.__ddiCardHoverImgInit = true;
  function initPanel(panel){
    if(!panel) return;
    var img = panel.querySelector('.card__img-second');
    if(!img || img.__ddiInit) return;
    img.__ddiInit = true;
    if(!img.getAttribute('data-src')){ img.classList.add('is-ready'); return; }
    var done = function(){ img.classList.add('is-ready'); };
    img.addEventListener('load', done, {once:true});
    img.addEventListener('error', function(){ img.remove(); }, {once:true});
    if(img.dataset.srcset){ img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
    img.src = img.dataset.src;
    img.removeAttribute('data-src');
    if(img.complete && img.naturalWidth) done();
  }
  document.addEventListener('mouseover', function(e){
    var panel = e.target.closest('[data-card-img]');
    if(panel) initPanel(panel);
  }, {passive:true});
  var isDesktop = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if(!isDesktop || typeof IntersectionObserver === 'undefined') return;
  function prefetch(){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;
        initPanel(entry.target);
        io.unobserve(entry.target);
      });
    }, {rootMargin: '200px 0px'});
    document.querySelectorAll('[data-card-img]').forEach(function(p){ io.observe(p); });
  }
  var start = function(){ ('requestIdleCallback' in window) ? requestIdleCallback(prefetch, {timeout: 2000}) : setTimeout(prefetch, 800); };
  if(document.readyState === 'complete') start();
  else window.addEventListener('load', start, {once:true});
})();
